import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import Api, { exceptionNotificationAPI } from '../../services/api';
import { Container } from './styles';
import { Form } from '@unform/web';
import FormInput from '../../components/FormInput';
import Button from '../../components/Button';
import CancelButton from '../../components/CancelButton';
import { AiOutlineDelete } from 'react-icons/ai'
import { success_message } from '../../components/Toast/index.jsx';
import getValidationErrors from '../../utils/getValidationErrors';


const CultureForm = () => {
    const [sectionOptions, setSectionOptions] = useState();
    const navigate = useNavigate();
    const { id } = useParams();
    const formRef = useRef(null);
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isColumnsLoading, setIsColumnsLoading] = useState(false);
    const activeOptions = [
        { value: true, text: "Yes" },
        { value: false, text: "No" }
    ];

    useEffect(() => {
        async function load() {
            setIsLoading(false)
        }
        load()
    }, []);

    useEffect(() => {
        if (data === null && id != null && !isLoading) {
            console.log(sectionOptions)
            loadDataEdit();
        }

    }, [isLoading]);


    const loadDataEdit = async () => {
        if (!isLoading) {
            setIsColumnsLoading(true);
            try {
                const result = await Api.get(`culture/get?id=${id}`);
                if (result && result.data && result.data.response) {
                    const culturesList = result.data.response.culturesList || [];
                    console.log(culturesList)
                    const options = [{ value: 0, text: "None" }];
                    culturesList.forEach((item) => {
                        options.push({ value: item.columnRowOrder || 0, text: item.name || '' });
                    });

                    console.log(result.data.response, "aa")

                    setColumnsRow({ ...columnsRow, column: culturesList });
    
    
                    if (result.data.response) {
                        formRef.current.setData(result.data.response);
                        setData(result.data.response);
                    }
                    
                }
            } catch (error) {
                console.log(error)
                // exceptionNotificationAPI(error);
            } finally {
                setIsColumnsLoading(false);
            }
        }
    };    

    const getObjects = (currentObject, fragments) => {
        if (fragments.length > 0) {
            var object = currentObject[fragments[0]];

            if (object != null) {
                fragments.shift();
                return getObjects(object, fragments);
            }
            else {
                return "";
            }
        }

        return currentObject;
    }

    const handleSubmit = async (data, e) => {
        try {
            var obj = {}
            var postObj = {};
            const submitUrl = `Culture/new`;

            postObj["cultureID"] = id;

            Sectionfields.map(f => {
                if (f.required !== undefined && f.required === false) {
                    return null;
                } else {
                    return obj[f.name] = Yup.string().required(`${f.label} is required`);
                }
            })

            const schema = Yup.object().shape(obj);

            await schema.validate(data, {
                abortEarly: false,
            });

            Sectionfields.map(f => {
                return postObj[f.name] = data[f.name]
            })

            postObj["CulturesList"] = columnsRow.column;

            await Api.post(submitUrl, postObj).then((result) => {
                if (result && result.data) {
                    success_message("Saved successfuly");
                    navigate(-1);
                }
            });

        } catch (error) {
            if (error instanceof Yup.ValidationError) {
                const errors = getValidationErrors(error);

                formRef.current.setErrors(errors);

                return;
            }

            exceptionNotificationAPI(error);
        }
    }

    const handleLoadColumnRowInputs = (value) => {
        var length = columnsRow.column.length;

        var newColumn = {
            name: null,
            columnRowOrder: length + 1,
            type: 1,
        }

        columnsRow.column.push(newColumn);

        setColumnsRow({ ...columnsRow, column: columnsRow.column });
    }

    const handleRemoveColumnRowInputs = (value, i) => {
        let updatedColumns = [...columnsRow.column];
    
        if (updatedColumns[i]) {
            updatedColumns[i] = { ...updatedColumns[i], isDeleted: true };
        }
    
        setColumnsRow({ ...columnsRow, column: updatedColumns });
    };    

    const setColumn = async (col, colIndex, index, value, label) => {
        let updatedColumns = [...columnsRow.column];
        let myCol = { ...updatedColumns[colIndex] };
    
        if (myCol != null) {
            if (value != null) { 
                switch (index) {
                    case 0:
                        myCol.description = value;
                        break;
                    case 1:
                        myCol.isActive = value;
                        break;
                    case 2:
                        myCol.type = value;
                        break;
                    case 3:
                        myCol.kpiReference = value;
                        break;
                    case 4:
                        myCol.minimumQuantity = value;
                        break;
                    case 5:
                        myCol.isParentColumn = value;
                        break;
                    case 6:
                        myCol.parentColumnRowID = value;
                        break;
                    case 7:
                        myCol.columnRowCompany = value;
                        break;
                    default:
                        break;
                }
            }
    
            updatedColumns[colIndex] = myCol;
    
            setColumnsRow({ ...columnsRow, column: updatedColumns });
        }
    };    
    
    const Sectionfields = [
        {
            label: "Description",
            name: "cultureDisplayName",
            type: "input"
        },
        {
            label: "Is Active",
            name: "isActiveCulture",
            type: "select",
            options: activeOptions
        },
    ]

    const [columnsRow, setColumnsRow] = useState({
        column: [{
            "name": " ",
            "columnRowOrder": 1,
            "type": 1,
        }]
    });

    const ColumnRowfields = [

        {
            label: "Description",
            name: "description",
            type: "input",
            required: true
        },
        {
            label: "Is Active",
            name: "isActive",
            type: "select",
            options: activeOptions
        },
    ]

    return (
        !isLoading ?
            <Container className="container">
                <div>
                    <h3>{(id != null) ? "Edit" : "New"} Culture</h3>
                    <Form onSubmit={handleSubmit} ref={formRef}>
                        <table className="table table-striped" style={isColumnsLoading && isLoading ? { visibility: 'hidden' } : { visibility: 'visible' }}>
                            <tbody>
                                {
                                    Sectionfields.map((f, i) => {
                                        if (id !== undefined && f.editable !== undefined && f.editable === false) {
                                            return <></>
                                        }
                                        else {
                                            return (<>
                                                <tr key={i + "Tr"} id={f.name + "Tr"}>
                                                    <td width="25%">
                                                        <label>
                                                            {`${f.label}`}  {f.required === undefined || f.required === true ? <span className="required">*</span> : <></>}
                                                        </label>
                                                    </td>
                                                    <td width="75%">
                                                        {f.type == "customOptions" ?
                                                           <></>
                                                            :
                                                            <FormInput
                                                                name={f.name}
                                                                id={f.name}
                                                                disabled={f.disabled ? f.disabled : false}
                                                                checked={f.checked}
                                                                inputType={f.type}
                                                                options={f.options}
                                                                onChange={(e) => (f.onChanged != null) ? f.onChanged(e.target.value) : null} />
                                                        }
                                                    </td>
                                                </tr>
                                            </>)
                                        }
                                    })
                                }
                            </tbody>
                        </table>
                        <div className='mt-5'>
                            <a className="addnewLine btn-primary" style={{ padding: '0.5rem 1rem', textDecoration: 'none', cursor: 'pointer' }} onClick={() => handleLoadColumnRowInputs()}>Add New Type</a>
                        </div>
                        {
                            !isColumnsLoading ?
                                <table className="table table-striped my-5">
                                    <thead>
                                        <tr><th scope="col">{"Index"}</th>
                                            {ColumnRowfields.map((cs) => {
                                                return (
                                                    <th scope="col text-center">{cs.label}</th>
                                                )
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {columnsRow.column.filter(col => !col.isDeleted).map((col, colinx) => {
                                            return (
                                                <tr>
                                                    <td>
                                                        <label>
                                                            {colinx + 1}
                                                        </label>
                                                    </td>
                                                    {ColumnRowfields.map((c, ind) => {
                                                        console.log(col[c.name], "c")
                                                        return (
                                                            ind == 0 ?
                                                                <td scope="row">
                                                                    <FormInput
                                                                        name={c.name}
                                                                        id={`col-${colinx}-${c.name}`}
                                                                        disabled={c.disabled ? c.disabled : false}
                                                                        checked={c.checked}
                                                                        inputType={c.type}
                                                                        options={c.options}
                                                                        value={col[c.name]}
                                                                        onChange={(e) => setColumn(col, colinx, ind, e.target.value, c.label)}
                                                                    />
                                                                </td>
                                                                :
                                                                c.type == "requestModalInput" ?
                                                                    <></>
                                                                    :
                                                                    <td style={c.type == "number" ? { width: "7rem" } : c.type == "select" ? { width: "17rem" } : { width: "10rem" }}>
                                                                        <FormInput
                                                                            name={c.name}
                                                                            id={`col-${colinx}-${c.name}`}
                                                                            disabled={c.disabled ? c.disabled : false}
                                                                            checked={col[c.name]}
                                                                            inputType={c.type}
                                                                            options={c.options}
                                                                            value={col.isActive}
                                                                            onChange={(e) => setColumn(col, colinx, ind, e.target.value, c.label)}
                                                                        />
                                                                    </td>
                                                        )
                                                    })}
                                                    {colinx != 0 ? <td><AiOutlineDelete size={20} onClick={(e) => handleRemoveColumnRowInputs(e.target.value, colinx)} /></td> : <></>}
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                                :
                                <></>
                        }
                        <div className="d-flex flex-row mt-2">
                            <CancelButton />
                            <Button type="submit">Save</Button>
                        </div>
                    </Form>

                </div>
            </Container>
            : <></>
    );
}

export default CultureForm;


